import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Checkbox } from '@mui/material';
import UserGroupListFiltersComponent from './UserGroupListFiltersComponent';

const UserGroupListHeaderComponent = ({ setAllCheckbox, dispatch, filters, onChangeFilterValue }) => {
  const onSetAll = event => {
    dispatch({
      type: 'OnSetAllBegin',
      checkedValue: event.target.checked
    });
  };

  return (
    <Grid item xs={12} sm={12}>
      <Checkbox indeterminate={setAllCheckbox === null} checked={setAllCheckbox} color='primary' onChange={onSetAll} />
      <UserGroupListFiltersComponent filters={filters} onChangeFilterValue={onChangeFilterValue} />
    </Grid>
  );
};

UserGroupListHeaderComponent.propTypes = {
  setAllCheckbox: PropTypes.bool,
  dispatch: PropTypes.func,
  filters: PropTypes.object.isRequired,
  onChangeFilterValue: PropTypes.func
};

export default UserGroupListHeaderComponent;
